import React, { PureComponent } from 'react';
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import { getUrlParams } from '../../../routes'
import { Button, Card, Form, notification, Tabs } from 'antd'
import _ from 'lodash'

import { hideLoader, showLoader } from '../../../modules/actions'
import Request from '../../../request'
import { connect } from 'react-redux'

// const Option = Select.Option

const TabPane = Tabs.TabPane
// const config = {
//     rules: [{type: 'object', required: true, message: 'Please select time!'}]
// }

// following variables needed for update country
let docLoaded = null
let countryId = null

@Form.create()
class AddContactDetails extends PureComponent {
    state = {
        id: '',
        count: 0,
        userGroupArr: [],
        activeKey: '0',
        editing: false
    }

    reload = () => {
        this.table.current.reload()
    }

    deleteContact = async data => {
        this.setState({ loading: true })

        await Request.deleteContactDetails(data)

        this.setState({ loading: false })

        this.reload()

        notification.success({
            message: 'Deleted Successfully',
            duration: 20
            // key: `${data.val._id}-close`
        })
    }
    callback = key => {
        let inputTypes = this.state.inputTypes

        if (countryId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
            inputTypes[key - 1].opened = true
            let tempObj = {}
            _.each(inputTypes[key - 1].fields, (v, k) => {
                tempObj[v.key] = docLoaded[v.key]
            })

            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj)
            }, 10)
        }
    }
    handleSubmit = e => {
        const { dispatch, form } = this.props

        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                dispatch(showLoader())

                let x = null

                if (this.state.id) {
                    valData._id = this.state.id
                    x = await Request.updateContactDetails(valData)
                } else {
                    x = await Request.addContactDetails(valData)
                }

                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: this.state.id
                            ? `Updated Successfully`
                            : 'Added successfully'
                    })
                    this.props.form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.message
                    })
                }
            }
        })
    }
    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
            let data = await Request.loadContactDetails({
                ...params,
                regExFilters: ['contactName', 'email', 'mobile']
            })
            this.setState({ count: data.total })
            resolve(data)
        })
    }
    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }
    loadGroups = () => {
        Request.loadGroups().then(resp => {
            if (resp && resp.result) {
                resp.result = resp.result.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.groupName })
                    return temp
                }, [])
                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][4].options = resp.result
                this.setState({ inputTypes: inputTypes })
                this.refreshFxn()
            }
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    async componentDidMount() {
        let { data: userGroupArr } = await Request.loadGroups({ results: 10000 })
        this.setState({ userGroupArr })

        let data1 = await getUrlParams(
            'editContactDetails',
            this.props.pathname
        )

        if (data1 && data1.id) {
            Request.contactDetailsById({ _id: data1.id }).then(
                ({ doc, error, message }) => {
                    if (!error) {
                        this.setState({
                            id: doc._id
                        })
                        this.props.form.setFieldsValue({
                            contactName: doc.contactName,
                            mobile: doc.mobile,
                            email: doc.email,
                            fax: doc.fax,
                            homePhone: doc.homePhone,
                            address: doc.address,
                            skypeComments: doc.skypeComments,
                            businessName: doc.businessName,
                            website: doc.website,
                            businessPhone: doc.businessPhone,
                            selectGroup: doc.selectGroup._id
                        })
                    } else {
                        notification.error({
                            message: 'Error Getting Data',
                            description: message
                        })
                    }
                }
            )
        }
    }

    render() {

        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props

        let inputTypes = {
            fields: [
                { label: 'Contact Name', key: 'contactName', required: true },
                { label: 'Business Name', key: 'businessName', required: true },
                { label: 'Email', key: 'email', required: true },
                { label: 'Website', key: 'website', required: true },
                { label: 'Business Phone', key: 'businessPhone', required: true },
                { label: 'Home Phone', key: 'homePhone', required: true },
                { label: 'Fax', key: 'fax', required: true },
                { label: 'Mobile', key: 'mobile', required: true },
                { label: 'Address', key: 'address', required: true },
                { label: 'Skype ID Comments', key: 'skypeComments', required: true },
                {
                    label: 'Select Group',
                    key: 'selectGroup',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Group',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.groupName,
                    type: 'select',
                    disabled: false,
                    options: this.state.userGroupArr ? this.state.userGroupArr : [],
                    onChange: group => {
                        setFieldsValue({
                            selectGroup: group
                        })
                    }
                }
            ]
        }
        const columns = [
            {
                title: 'Contact Name',
                key: 'contactName',
                dataIndex: 'contactName',

                searchTextName: 'contactName',
                filterRegex: true
            },
            {
                title: 'Business Name',
                key: 'businessName',
                dataIndex: 'businessName'
            },
            {
                title: 'Mobile',
                key: 'mobile',
                dataIndex: 'mobile',

                searchTextName: 'mobile',
                filterRegex: true
            },
            {
                title: 'Email',
                key: 'email',
                dataIndex: 'email',

                searchTextName: 'email',
                filterRegex: true
            },

            {
                title: 'UserGroup',
                key: 'selectGroup',
                dataIndex: 'selectGroup',

                render: (val, record) => {
                    {
                        return (
                            <div>
                                {record.selectGroup ? record.selectGroup.groupName : ''}
                            </div>
                        )
                    }
                }
            },

            /* {
               key: 'actions',
               title: 'Actions',
               render: val => {
                 return (
                   <div>
                     <RightsWrapper myRight={'Contact.edit'}>
                       <Tooltip title="Edit Details">
                         <Button
                           shape="circle"
                           onClick={() => {
                             dispatch(
                               getPushPathWrapper('contactDetails.editContactDetails', {
                                 id: val._id
                               })
                             )
                           }}
                           icon="edit"
                         />
                       </Tooltip>
                     </RightsWrapper>
                     <RightsWrapper myRight={'Contact.delete'}>
                       <Tooltip title="Delete Contact Detail">
                         <Popconfirm
                           title="Are you sure delete this Contact?"
                           onConfirm={() => {
                             this.deleteContact(val)
                           }}
                           onCancel={() => {
                             console.log()
                           }}
                           okText="Yes"
                           cancelText="No">
                           <Button type="danger" shape="circle" icon="delete"/>
                         </Popconfirm>
                         ,
                     </Tooltip>
                     </RightsWrapper>
                   </div>
                 )
               }
             }*/
        ]

        // const formItemLayout = {
        //     labelCol: {
        //         xs: {span: 24},
        //         sm: {span: 8},
        //         md: {span: 8}
        //     },
        //     wrapperCol: {
        //         xs: {span: 24},
        //         sm: {span: 16},
        //         md: {span: 12}
        //     }
        // }

        // const submitFormLayout = {
        //     wrapperCol: {
        //         xs: {span: 24, offset: 0},
        //         sm: {span: 10, offset: 7},
        //         md: {span: 12, offset: 8}
        //     }
        // }

        return (
            <PageHeaderWrapper title={'Contact Management'}>
                <Card bordered={true}>
                    <Tabs onChange={this.callback}

                        type="card">
                        <TabPane tab={'Add Contact Detail'} key={0}>
                            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                                <GetAllFormFields
                                    inputSchema={inputTypes}
                                    refresh={this.refreshFxn}
                                    getFieldDecorator={getFieldDecorator}
                                />
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10, marginLeft: '33%' }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Form>
                        </TabPane>

                        <TabPane tab={'ContactDetails List'} key={1}>
                            <h2>{`Contact Detail: ${this.state.count}`}</h2>
                            <TableComp
                                columns={columns}
                                ref={this.table}
                                apiRequest={params => this.apiRequest(params, columns)}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 20,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>

                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddContactDetails)
